import { ReactNode } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { Loader, Shield } from 'lucide-react'
import { LoginButton } from './LoginButton'
import { VERSION } from '../config/version'

interface AuthGuardProps {
  children: ReactNode
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isLoading, user } = useAuth()

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <Loader className="w-8 h-8 animate-spin text-brand-600 mx-auto mb-4" />
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated || !user) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
          <div className="mb-6">
            <Shield className="w-16 h-16 text-brand-600 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Welcome to BrandedApp v{VERSION}</h1>
            <p className="text-gray-600">
              Sign in with your Google account to start creating and managing your mobile apps.
            </p>
            <p className="text-xs text-gray-500 mt-2">
              Frontend/Backend Connected - Updated Auth System
            </p>
          </div>
          
          <LoginButton />
          
          <div className="mt-6 text-sm text-gray-500">
            <p>By signing in, you agree to our Terms of Service and Privacy Policy.</p>
          </div>
        </div>
      </div>
    )
  }

  return <>{children}</>
} 